<template>
  <v-dialog v-model="dialog" width="800">
    <template v-slot:activator="{ on }">
      <v-btn class="my-2 ml-3" color="primary" outlined small v-on="on">
        Import Epic ID
      </v-btn>
    </template>

    <v-card>
      <v-card-title> Import Epic IDs </v-card-title>

      <v-stepper v-model="step" vertical>
        <v-stepper-step :complete="step > 1" step="1">
          Upload File
          <small
            >Import Epic IDs back into Valet to avoid overwriting records on
            future export</small
          >
        </v-stepper-step>
        <v-stepper-content step="1">
          <v-card>
            <v-card-text>
              <v-form v-model="valid">
                <v-file-input
                  :rules="ruleList"
                  accept=".xlsx"
                  label="File with Epic IDs Filled out"
                  v-model="file"
                ></v-file-input>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" outlined small @click="reset"
                >Cancel</v-btn
              >
              <v-btn
                color="primary"
                outlined
                small
                :disabled="!file"
                @click="importFile"
              >
                Import
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-step :complete="step > 2" step="2">
          Upload Report
        </v-stepper-step>
        <v-stepper-content step="2">
          <v-card>
            <v-card-text>
              <v-expansion-panels v-if="report">
                <panel-epic-id-import
                  :result-list="report.created"
                  color="green"
                  label="Created"
                  v-if="Array.isArray(report.created)"
                ></panel-epic-id-import>

                <panel-epic-id-import
                  :result-list="report.updated"
                  color="yellow"
                  label="Updated"
                  v-if="Array.isArray(report.updated)"
                ></panel-epic-id-import>

                <panel-epic-id-import
                  :result-list="report.failed"
                  color="red"
                  label="Failed"
                  v-if="Array.isArray(report.failed)"
                ></panel-epic-id-import>

                <panel-epic-id-import
                  :result-list="report.skipped"
                  color="grey"
                  label="Skipped"
                  v-if="Array.isArray(report.skipped)"
                ></panel-epic-id-import>
              </v-expansion-panels>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" outlined small @click="reset">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
import { get } from "lodash";
import axios from "axios";

import PanelEpicIdImport from "./Panel";

export default {
  components: {
    PanelEpicIdImport,
  },
  data() {
    return {
      report: undefined,
      dialog: false,
      file: undefined,
      step: 1,
      ruleList: [
        value => !value || value.size < 2e6 || "File must be under 2 MB",
      ],
      valid: undefined,
    };
  },
  methods: {
    reset() {
      this.dialog = false;
      this.file = undefined;
      this.step = 1;
    },
    async importFile() {
      const { entityName, id: epicMappingId } = this;

      const formData = new FormData();

      formData.append("file", this.file);

      let response;
      try {
        response = await axios({
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          method: "post",
          url: `/api/entity/${entityName}/epicMapping/${epicMappingId}/epicIdImport`,
        });
      } catch (e) {
        console.error(e);

        let message = get(e, "response.data.message");

        // Default error message if there is none
        if (!message) {
          message = `Error importing Epic IDs`;
        }

        this.$notifyError({ message });

        return;
      }

      const {
        data: { result },
      } = response;

      this.report = result;
      this.step = 2;
    },
  },
  props: {
    entityName: {
      requried: true,
      type: String,
    },
    id: {
      required: true,
      type: Number,
    },
  },
};
</script>
